import React, { useContext, useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import MostUsedModes from "./components/MostUsedModes";
import { ReactComponent as VoucherIcon } from "assets/img/svg/fi_tag.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { useGetCollectPaymentContext } from "../context";
import { getDropdowns, paymentMode } from "./components/constant";
import { endpoint } from "views/pages/manage/common/constant";
import { UserDetails } from "appContext";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import Vouchers from "./vouchers/Vouchers";
import CollectPayment from "./common/CollectPayment";
import ALoader from "views/pages/manage/common/a-loader";
import { getMaxPaymentModeLimit } from "../apis";
import { paymentCodeMapping } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/constant";
import { isChequeEnabled } from "../utils";
const SelectPaymentMode = (props) => {
  const [voucherCount, setVoucherCount] = useState(0);
  const [vouchersList, setVoucherList] = useState([]);
  const [voucherLoader, setVoucherLoader] = useState(false);
  const [accessiblePaymentModeList, setAccessiblePaymentModeList] = useState(
    []
  );
  const {
    modifyPaymentModeData,
    currentPaymentMode,
    setBankDropdown,
    studentBasicDetails,
    roleId,
    setBankMasterId,
    balanceMode,
    setPaymentModeIdLimitList,
    loader,
    setloader,
    setPaymentModeForm,
    selectedCharges,
    vouchersDialogOpen: isOpen,
    setVouchersDialogOpen: setOpen,
    forCentralizedAdmission,
    // getPaymentModeAndVouchersReqObj,
    getPaymentModesAndVouchers,
    getFilteredPaymentModes = (modes) => modes
  } = props?.contextValue;

  useEffect(() => {
    const getDropdown = async () => {
      setloader(true);
      const dropdown = await getDropdowns();
      setBankDropdown(dropdown);
      setloader(false);
    };
    getDropdown();
  }, []);
  // const [isOpen, setOpen] = useState(true&&selectedCharges);
  const isRegularCharges = (selectedCharges?.REGULAR_CHARGES|| []).length>0?true:false ; 
   const getBankMasterIdAndVouchers = async () => {
      // const url = endpoint.paymentCollection.getVouchersAndPaymentMode;
      // const req = getPaymentModeAndVouchersReqObj();
      try {
        setVoucherLoader(true);
        let response = await getPaymentModesAndVouchers();
        if (response?.code === 200) {
          const voucherList = [
            ...(response?.data?.phxVoucherDtoList ?? []),
            ...(response?.data?.erpVoucherDtoList ?? []) ,
          ];
          const reverseVoucherList = voucherList.reverse();
          let newUpdatedList = reverseVoucherList.map((item, index) => {
            return { ...item, id: index, vId: item?.id };
          });
          let latestCardTransaction = newUpdatedList.find(
            (item) =>
              (item.type == "CC" || item.type == "DB") && item?.status == "PAID"
          );
          if (latestCardTransaction) {
            latestCardTransaction = {
              ...latestCardTransaction,
              isAutoApplied: true,
            };
            newUpdatedList[latestCardTransaction?.id] = latestCardTransaction;
          }
          setVoucherList(
            newUpdatedList.map((item, index) => ({ ...item, id: index }))
          );
          setVoucherCount(voucherList.length);
          let masterIdMapping = {};
          let tempAccessiblePaymentModeList = [];
          for (let i in response?.data?.paymentModeMasterDTOList) {
            masterIdMapping = {
              ...masterIdMapping,
              [response?.data?.paymentModeMasterDTOList[i]
                ?.paymentModeDispValue]:
                response?.data?.paymentModeMasterDTOList[i]?.id,
            };
            if (
              response?.data?.paymentModeMasterDTOList[i]
                ?.paymentModeDispValue == "Link" &&
              props?.isReceipt
            )
              continue;
            else
              tempAccessiblePaymentModeList.push(
                response?.data?.paymentModeMasterDTOList[i]
                  ?.paymentModeDispValue
              );
          }

          //show selective payment modes in case of centralized Admission
          if (forCentralizedAdmission)
            tempAccessiblePaymentModeList =
              tempAccessiblePaymentModeList.filter((paymentMode) =>
                ["Link", "QRC"].includes(paymentMode)
              );
          //custom filtering logic
          tempAccessiblePaymentModeList = getFilteredPaymentModes(tempAccessiblePaymentModeList);    
          //If Jodo concession opt then not eligible for other payment mode
          const isJodoEligible = 
          studentBasicDetails?.isPaymentModeJODO &&
          isRegularCharges &&
          studentBasicDetails?.programAction !== "DISC" &&
          !studentBasicDetails?.detailsMap?.jodoBouncedEnableOtherModes;

        //  if(isChequeEnabled(studentBasicDetails))
        //    tempAccessiblePaymentModeList = tempAccessiblePaymentModeList.filter((item)=>['CHKL','DD','CMP','ADJ','SDJ'].includes(item))
        const accessibleModes = isJodoEligible 
          ? tempAccessiblePaymentModeList.filter((item)=>(["JODO","CMP","SDJ","ADJ"].includes(item)))
          : tempAccessiblePaymentModeList;
          
          setAccessiblePaymentModeList(accessibleModes);
          setBankMasterId(masterIdMapping);
          setVoucherLoader(false);
        } else {
          setVoucherLoader(false);
          failureToast(response?.message);
        }
      } catch (err) {
        setVoucherLoader(false);
        console.error(err);
      } finally {
        selectedCharges && setOpen(true && selectedCharges);
      }
    };
  useEffect(() => {
    const getMaxLimit = async () => {
      setloader(true);
      const res = await getMaxPaymentModeLimit();
      setPaymentModeIdLimitList({
        paymentModeIdList: res?.paymentModeIds,
        maxLimit: res?.maxPaymentLimit,
      });
      setloader(false);
    };
    getMaxLimit();
    getBankMasterIdAndVouchers();
  }, []);
  
  const SelectedPaymentMode =
    paymentMode?.[currentPaymentMode] ??
    paymentMode?.[paymentCodeMapping?.[currentPaymentMode]];

  const getSelectPaymentMode = (props) => {
    return (
      <>
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-start">
            <div className="dark-text label-color mb-2">
              {props?.isReceipt
                ? "Select a new payment mode"
                : "Select Payment Mode"}
            </div>
            {props?.isReceipt ? (
              <CrossIcon onClick={props?.handleClose} />
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  border: "1px solid var(--Green-50, #05945B)",
                  borderRadius: "4px",
                  padding: "4px 10px",
                }}
                onClick={() => {
                  setOpen(true);
                }}
              >
                <VoucherIcon />{" "}
                <span
                  style={{ color: "#05945B" }}
                  className="label-text ml-1 cursor"
                >
                  Vouchers Available • {voucherCount}
                </span>
              </div>
            )}
          </div>
          {props?.isReceipt && (
            <div
              className="global-font-size label-color mb-2"
              style={{ fontWeight: 400, lineHeight: "24px", marginTop: "-8px" }}
            >
              {props?.subHeading}
            </div>
          )}
          <div className="d-flex" style={{ gap: "6px" }}>
            <MostUsedModes
              contextValue={props?.contextValue}
              accessiblePaymentModeList={accessiblePaymentModeList}
              isReceipt={props?.isReceipt}
              oldPaymentMode={props?.oldPaymentMode}
            />
          </div>
        </div>
        <div style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
        <div style={props?.isReceipt ? {} : { minHeight: "212px" }}>
          {(loader || voucherLoader) && <ALoader />}
          {balanceMode && Object.keys(modifyPaymentModeData).length == 0 ? (
            <CollectPayment module={props.module} />
          ) : (
            <SelectedPaymentMode
              contextValue={props?.contextValue}
              isReceiptEdit={props?.isReceipt}
              rowId={props?.rowId}
              handleClose={props?.handleClose}
            />
          )}
        </div>
      </>
    );
  };
  useEffect(() => {
    setPaymentModeForm((prev) => ({
      ...prev,
      paymentMode: currentPaymentMode,
    }));
  }, [currentPaymentMode]);
  {console.log("accessiblePaymentModeList", accessiblePaymentModeList)}

  return !props?.isReceipt ? (
    <div
      style={props?.isReceipt ? { width: "100%" } : { width: "67%" }}
      className="select-payment-mode"
    >
      <Card>
        <CardBody>{getSelectPaymentMode(props)}</CardBody>
      </Card>
      <div>
        <Vouchers
          isOpen={isOpen}
          setOpen={setOpen}
          vouchersList={vouchersList}
          setVoucherList={setVoucherList}
          setVoucherCount={setVoucherCount}
          voucherLoader={voucherLoader}
          setVoucherLoader={setVoucherLoader}
          accessiblePaymentModeList={accessiblePaymentModeList}
          module={props.module}
          getVouchers={getBankMasterIdAndVouchers}
        />
      </div>
    </div>
  ) : (
    getSelectPaymentMode(props)
  );
};

export default SelectPaymentMode;
